import privacyPreferences from '../../../common/privacy/privacy_preferences';
import SlideToggleComponent from '../../components/slide_toggle/slide_toggle';

interface PrivacyGroupsElements {
  parent: HTMLElement;
  toggles: HTMLElement[];
}

class PrivacyGroupsComponent {
  private readonly selectors: { [key: string]: string } = {
    parentById: 'uf-privacy-groups',
    toggle: '.uf-toggle',
  };

  private dom!: PrivacyGroupsElements;

  private readonly privacyPreferences = privacyPreferences;

  public constructor() {
    if (this.setBindings()) {
      this.initToggles();
    }
  }

  private setBindings = (): boolean => {
    const parent = document.getElementById(this.selectors.parentById) as HTMLElement;
    if (!parent) return false;

    const toggles = [...parent.querySelectorAll(this.selectors.toggle)] as HTMLElement[];
    if (!toggles || !toggles.length) return false;

    this.dom = { parent, toggles };
    return true;
  };

  private initToggles = (): void => {
    this.dom.toggles.forEach(
      (toggleElement: HTMLElement) => new SlideToggleComponent(toggleElement, this.toggleCallback),
    );
  };

  private toggleCallback = (event: Event, slideToggle: SlideToggleComponent): void => {
    const privacyGroupId = slideToggle.element.dataset.privacyGroupId || '';
    const toggleValue = slideToggle.getValue();
    const methodName = toggleValue ? 'acceptById' : 'rejectById';
    this.privacyPreferences[methodName](privacyGroupId);
  };
}

export default PrivacyGroupsComponent;
